import Confirm from "./Confirm";
import Object from "./Object";
import KeyPermission from "./KeyPermission";

export default {
  PERMISSIONS: KeyPermission,
  OBJECT: Object,
  CONFIRM: Confirm,
};
